import { t } from '@/i18n';
import { z } from 'zod';

const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];

export const modalFormSchema = z.object({
  title: z.string().min(1, t('pages.application_videos_channel.components.video_edit_modal.schema.required')),
  category_video_uuid: z.string().min(1, t('pages.application_videos_channel.components.video_edit_modal.schema.required')),
  video_url: z.string().min(1, t('pages.application_videos_channel.components.video_edit_modal.schema.required')),
  team_uuid: z.string().optional(),
  file: z
    .any()
    .optional()
    .refine(
      file => !file || ACCEPTED_IMAGE_TYPES.includes(file.type),
      t('pages.application_videos_channel.components.video_edit_modal.schema.required_file'),
    ),
});

export type ModalFormData = z.infer<typeof modalFormSchema>;
